import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
/**
 * 格式化时间
 *
 * @param time
 * @Return 2021/04/19-04/26
 */
export function formatDateTime(time, type) {
  if (time) {
    time = time.replace(/-/g, '/');
  }
  var yy = new Date(time).getFullYear();
  var mm = new Date(time).getMonth() + 1;
  mm = (mm + '').length > 1 ? mm : '0' + mm;
  var dd = new Date(time).getDate();
  dd = (dd + '').length > 1 ? dd : '0' + dd;
  var ret = '';
  console.log(time, yy, mm, dd);
  if (type == 1) {
    ret = dd + '/' + mm + '/' + yy;
  } else if (type == 2) {
    ret = dd + '/' + mm;
  }
  return ret;
}

/**
 * 格式化时间
 *
 * @param time
 * @Return 2021/04/19-04/26
 */
export function format2DateTime(time, type) {
  if (time) {
    time = time.replace(/-/g, '/');
  }
  console.log('before: ' + time);
  var yy = new Date(time).getFullYear();
  var mm = new Date(time).getMonth() + 1;
  mm = (mm + '').length > 1 ? mm : '0' + mm;
  var dd = new Date(time).getDate();
  dd = (dd + '').length > 1 ? dd : '0' + dd;
  return dd + '.' + mm + '.' + yy;
}

// /**
//  * 比较时间大小
//  *
//  * @param d1
//  * @param d2
//  * @returns {boolean}
//  */
// export function compareDate (d1, d2) {
//   let reg = new RegExp('-', 'g')
//   return ((new Date(d1.replace(reg, '/'))) > (new Date(d2.replace(reg, '/'))))
// }